import axios from 'axios'
import { ENDPOINTS } from '@/config/endpoints'

// Track an event to the analytics endpoint
export async function trackEvent({ sessionId, variantId, eventType, sourceId = null, metadata = {} }) {
  try {
    await axios.post(ENDPOINTS.TRACKING, {
      session_id: sessionId,
      event_type: eventType,
      variant_id: variantId,
      source_id: sourceId,
      metadata: {
        ...metadata,
        user_agent: navigator.userAgent,
        screen_width: window.innerWidth,
        referrer: document.referrer,
        timestamp: new Date().toISOString()
      }
    })
  } catch (err) {
    console.error('Tracking event failed:', err)
  }
}

// Track initial impression (only once per session)
export function trackInitialImpressionOnce({ sessionId, variantId, sourceId }) {
  const impressionKey = 'initial_impression_sent'

  if (!localStorage.getItem(impressionKey)) {
    trackEvent({
      sessionId,
      variantId,
      eventType: 'initialImpression',
      sourceId
    })

    localStorage.setItem(impressionKey, 'true')
  }
}

// Track Google Analytics event
export function trackGtagEvent(eventName, params = {}) {
  if (typeof gtag === 'function') {
    gtag('event', eventName, params)
  }
}

// Track Facebook pixel event
export function trackFbEvent(eventName, params = {}) {
  if (typeof fbq === 'function') {
    fbq('track', eventName, params)
  }
}

export const trackingService = {
  trackEvent,
  trackInitialImpressionOnce,
  trackGtagEvent,
  trackFbEvent
}
